<template>
    <div class="schedule_list">
        <div class="schedule_date">
            <div class="icon_date">
                <font-awesome-icon style="color: #fff;width: 8%;padding-top: 3px;text-align: end" icon="fa-solid fa-calendar-days" />
                <div @click="showDate" :value="dateShedule" class="date_span" style="  padding-top: 3px;font-weight: 500;">{{dateShedule}}</div>
            </div>
            <van-calendar color="#de5d0a" :title="$t('message.calendar')" v-model:show="show" :show-confirm="false" @confirm="onConfirm" :style="{ height: '90%' }" />
        </div>
        <div v-if="loading" class="data-loading" style="text-align: center;position: fixed;width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;">
          <van-loading size="35" color="#de5d0a" />
        </div>
        <div v-else class="schedule_cart">
            <div class="cart" v-for="getData in info" :key="getData.id">
                <div class="depa_arr_time">
                    <span class="dep_time" :class="{langKh: addFontKhmer}">{{$t('message.departureTime')}}</span>
                    <span class="arr_time" :class="{langKh: addFontKhmer}">{{$t('message.arrivalTime')}}</span>
                </div>
                <div class="date_time">
                    <span class="left_time">{{ getData.departure }}</span>
                    <span class="center_time">{{ getData.duration }}</span>
                    <span class="right_time">{{ getData.arrival }}</span>
                </div>
                <div class="date_img">
                    <img :src="require('@/assets/border-de.svg')" alt="">
                </div>
                <div class="seat_direct">
                    <span class="re_seat" :class="{langKh: addFontKhmer}">{{$t('message.remainingSeat')}}</span>
                    <span class="direct">Direct</span>
                </div>
                <div class="seat_num">
                    <span class="seat_sea" :class="{langKh: addFontKhmer}">{{ getData.seatAvailable }} {{$t('message.seats')}}</span>
                    <span class="seat_vip">{{ getData.transportationType }}</span>
                </div>
                <div class="seat_price">
                    <span class="seat_doller">{{ priceIncludeVat(getData.price) }} $</span>
                    <span class="seat_seat" :class="{langKh: addFontKhmer}">{{ getData.totalSeat }} {{$t('message.seats')}}</span>
                </div>
                <div class="btn_booking" v-if="getData.status == 1" @click="getJourney(getData.id, getData.price, getData.departure, getData.arrivalDate)">
                    <button :class="{langKh: addFontKhmer}">{{$t('message.booking')}}</button>
                </div>
                <div class="btn_leave" v-if="getData.status == 2">
                    <button :class="{langKh: addFontKhmer}">{{$t('message.leave')}}</button>
                </div>
                <div class="btn_leave" v-if="getData.status == 3">
                    <button :class="{langKh: addFontKhmer}">{{$t('message.notAvailable')}}</button>
                </div>
            </div>
        </div>
        <div v-if="NoData" class="not_data" style="width: 100%;height: 70vh;display: flex;align-items: center;justify-content: center;padding-left: 15px;padding-right: 15px;">
            <div style="line-height: 27px;text-align: center;font-size: 18px;padding: 5px;">
                <van-icon name="search" color="#de5d0a" style="font-size: 50px;" /> <br>
                <b :class="{langKh: addFontKhmer}">{{$t('message.sorry')}}</b>
                <p :class="{langKh: addFontKhmer}">{{$t('message.description')}}</p>
                <b style="color: #de5d0a;">
                    <router-link to="/Home" :class="{langKh: addFontKhmer}" style="color: #de5d0a;text-decoration: none;">{{$t('message.BackToSearch')}}</router-link>
                </b>
            </div>
        </div>
    </div>
    <div v-if="sheduleErrorIn">
        <div class="van-overlay" style="z-index: 2001;"></div>
        <div class="van-popup van-popup--center van-dialog van-dialog--round-button" role="dialog" tabindex="0" aria-labelledby="Information" style="z-index:2002;">
            <div class="van-dialog__header" :class="{langKh: addFontKhmer}">{{$t('message.information')}}</div>
            <div class="van-dialog__content">
                <div class="van-dialog__message van-dialog__message--has-title" :class="{langKh: addFontKhmer}">{{$t('message.msgInternet')}}</div>
            </div>
            <div class="van-action-bar van-safe-area-bottom van-dialog__footer">
                <button type="button" @click="closedsheduleError()" class="van-button van-button--danger van-button--large van-action-bar-button van-action-bar-button--danger van-action-bar-button--last van-action-bar-button--first van-dialog__confirm">
                    <div class="van-button__content">
                        <span class="van-button__text" :class="{langKh: addFontKhmer}">{{$t('message.ok')}}</span>
                    </div>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {Loading} from "vant";
import moment from 'moment';
import qs from 'qs';
import axios from "axios";
export default {
    components: {
        [Loading.name]: Loading
    },
    data() {
        return {
            url: localStorage.getItem("url"),
            bearer: localStorage.getItem("bearer"),
            currentDate:  moment().format('YYYY-MM-DD'),
            addFontKhmer: false,
            onLine: navigator.onLine,
            loading: true,
            show: false,
            NoData: false,
            dateShedule: localStorage.getItem('dateFrom'),
            info: [],
            sheduleErrorIn: false,
        }
    },
    methods: {
        closedsheduleError() {
            this.sheduleErrorIn = false;
            this.getDataSchedule();
        },

        getClear() {
            localStorage.removeItem('seat');
            localStorage.removeItem('seatlabel');
        },

        showDate() {
            this.show = true;
        },

        priceIncludeVat(price) {
            let overDue = "2023-06-01";
            if(this.currentDate > overDue) {
                return price;
            }else{
                var vat = 0;
                if(price > 0){
                    vat = price * 0.1;
                }
                return price + vat;
            }
        },

        formatDate(date) {
            if(date != ''){
                return moment(String(date)).format('YYYY-MM-DD');
            } else{
                return '';
            }
        },

        onConfirm(selectDate) {
            this.dateShedule = this.formatDate(selectDate);
            this.selectNewDate(this.dateShedule);
            this.show = false;
        },

        async selectNewDate(deteNew) {
            localStorage.setItem('dateFrom', deteNew);
            await this.getDataSchedule();
            if(localStorage.getItem("dateTo") != null) {
                localStorage.setItem("dateTo", deteNew);
            }
        },

        getJourney(id, price, departure, arrivalDate) {
            localStorage.setItem('journeyid', id);
            localStorage.setItem('price', price);
            localStorage.setItem('departure', departure);
            localStorage.setItem('arrivalDate', arrivalDate);
            this.$router.push("/choose-seat");
        },

        async getDataSchedule() {
            const data = {
                date: localStorage.getItem('dateFrom'),
                destinationFrom: localStorage.getItem('destinationFromId'),
                destinationTo: localStorage.getItem('destinationToId'),
                nationally: "1",
                type: localStorage.getItem('types'),
            };
            const url = this.url + `schedule/listByDate`;

            let config = {
                method: "POST",
                headers: {
                    "Authorization": this.bearer,
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                    "accept": "*/*",
                },
                data: qs.stringify(data),
                url,
            };
            this.loading = true;
            axios(config).then((response) => {
                this.loading = false;
                if (response.status == 200) {
                    if(response.data.header.result == false) {
                        this.NoData = true;
                    }else{
                        this.NoData = false;
                    }
                    if (response.data.header.result == true && response.data.header.statusCode == 200) {
                        this.info = response.data.body;
                        this.departures = response.data.body;
                    } else {
                        this.errored = true;
                    }
                } 
            }).catch((error) => {
                this.sheduleErrorIn = true;
                console.log(error);
            });
        }

    },
    created() {
        this.$bridge.callHandler("setBarTitle", { title: "Search Result", bgColor: "#de5d0a",color: "#ffffff"});

        if(this.$i18n.locale == "en") {
            this.addFontKhmer = false;
        }else {
            this.addFontKhmer = true;
        }

        if(!this.onLine){
            this.sheduleErrorIn = true;
        }else{
            this.getDataSchedule();
            this.getClear();
        }
        
    },
    mounted() {
        window.onpopstate = () => {
            this.goToHome();
        };
    },
    beforeUnmount() {
        window.onpopstate = null;
    },
}
</script>

<style>
    .schedule_list {
        width: 100%;
    }
    .schedule_list .schedule_date{
        box-shadow: rgb(0 0 0 / 10%) 0px 4px 12px;
        padding: 10px 8px 10px 8px;
        position: fixed;
        width: 100%;
        background: #fff;
    }
    .schedule_list .schedule_date .icon_date {
        display: flex;
        padding: 7px 0px 7px 0px;
        background: #de5d0a;
        border-radius: 8px;
    }
    .schedule_list .schedule_date .date_span {
        border: none;
        color: #fff;
        width: 92%;
        text-align: center;
        background: #de5d0a;
    }
    .schedule_list .schedule_cart{
        padding-top: 57px;
        width: 100%;
    }
    .schedule_list .schedule_cart .cart {
        margin: 10px;
        padding: 10px;
        border-radius: 8px;
        box-shadow: rgba(14, 30, 37, 0.12) 0px 2px 4px 0px,rgba(14, 30, 37, 0.32) 0px 2px 16px 0px;
    }
    .schedule_list .schedule_cart .cart .depa_arr_time {
        display: flex;
    }
    .schedule_list .schedule_cart .cart .depa_arr_time .dep_time{
        width: 50%;
    }
    .schedule_list .schedule_cart .cart .depa_arr_time .arr_time{
        width: 50%;
        text-align: end;
    }
    .schedule_list .schedule_cart .cart .date_time{
        margin-top: 5px;
        display: flex;
    }
    .schedule_list .schedule_cart .cart .date_time .left_time{
        font-weight: bold;
        width: 33.33%;
    }
    .schedule_list .schedule_cart .cart .date_time .center_time{
        width: 33.33%;
        text-align: center;
    }
    .schedule_list .schedule_cart .cart .date_time .right_time{
        font-weight: bold;
        width: 33.33%;
        text-align: end;
    }
    .schedule_list .schedule_cart .cart .seat_direct{
        display: flex;
    }
    .schedule_list .schedule_cart .cart .seat_direct .re_seat{
        width: 50%;
    }
    .schedule_list .schedule_cart .cart .seat_direct .direct{
        width: 50%;
        text-align: end;
    }
    .schedule_list .schedule_cart .cart .seat_num{
        margin-top: 5px;
        display: flex;
    }
    .schedule_list .schedule_cart .cart .seat_num .seat_sea{
        font-weight: bold;
        width: 50%;
    }
    .schedule_list .schedule_cart .cart .seat_num .seat_vip{
        font-weight: bold;
        width: 50%;
        text-align: end;
    }
    .schedule_list .schedule_cart .cart .seat_price{ 
        margin-top: 5px;
        display: flex;
    }
    .schedule_list .schedule_cart .cart .seat_price .seat_doller{
        color: #de5d0a;
        font-weight: bold;
        width: 50%;
    }
    .schedule_list .schedule_cart .cart .seat_price .seat_seat{
        color: #de5d0a;
        font-weight: bold;
        width: 50%;
        text-align: end;
    }
    .schedule_list .schedule_cart .cart .btn_booking button{
        color: #fff;
        font-weight: 500;
        width: 100%;
        margin-top: 5px;
        padding: 10px;
        border-radius: 8px;
        border: none;
        background: #de5d0a;
    }
    .schedule_list .schedule_cart .cart .btn_leave button{ 
        color: #fff;
        font-weight: 500;
        width: 100%;
        margin-top: 5px;
        padding: 10px;
        border-radius: 8px;
        border: none;
        background: gray;
    }
</style>